import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Container, Fiscal as BaseFiscal } from '@proman/interfaces/entity-interfaces';
import { ACL } from '@proman/services/acl.service';
import { QueryExpressionService } from '@proman/services/query-expression.service';
import { Entity } from '@proman/services/entity.service';

declare interface Fiscal extends BaseFiscal {
  _selected: boolean;
}

@Component({
  selector: 'root-container-fiscals-dialog',
  template: `
        <pro-dialog-title [title]="'container_fiscals' | translate"></pro-dialog-title>
        <section mat-dialog-content class="rows is-marginless">
          <mat-tab-group>
            <mat-tab label="List">
              <div [innerHtml]="text"></div>
            </mat-tab>
            @if (ACL.check('fiscal.edit')) {
              <mat-tab label="Assign">
                <div fxLayout="column">
                  @for (fiscal of availableFiscals; track fiscal.id) {
                    <pro-checkbox [value]="fiscal._selected" [config]="{ label: fiscal.cashRegisterRegistrationNo }" (onChange)="toggleAssignment(fiscal, $event)"></pro-checkbox>
                  }
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        </section>
        <pro-dialog-actions></pro-dialog-actions>
    `,
  styles: [ `

    `]
})

export class ContainerFiscalsDialogComponent implements OnInit {
  container: Container;
  availableFiscals: Fiscal[];
  text: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ACL: ACL,
    private Entity: Entity,
    private QueryExpression: QueryExpressionService,
    private dialogRef: MatDialogRef<ContainerFiscalsDialogComponent>,
  ) {
    this.container = this.data.container;
    this.Entity.get('fiscal').search({ 'container.id': this.QueryExpression.orNull(this.container.id) }).then((response: Fiscal[]) => {
      response.forEach((val: Fiscal) => {
        if (this.container.fiscals.some((fiscal => fiscal.id === val.id))) {
          val._selected = true;
        }
      })

      this.availableFiscals = response;
    })
  }

  ngOnInit() {
    this.container.fiscals.forEach((fiscal) => {
      this.text += `<a href="https://${fiscal.cashRegisterRegistrationNo}.fiscal.lt">${fiscal.cashRegisterRegistrationNo}</a><br>`;
    })
    if (!this.container.fiscals || this.container.fiscals.length === 0) {
      this.text = `<p>Container has no associated fiscals</p>`;
    }
  }

  toggleAssignment(fiscal: Fiscal, value: boolean) {
    if (value) {
      this.Entity.get('fiscal').addAssociation({ id: fiscal.id, container: this.container.id})
    } else {
      this.Entity.get('fiscal').removeAssociation({ id: fiscal.id, fiscal: this.container.id})
    }
  }
}
